import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=2b4131e5&scoped=true&"
import script from "./CloseBtn.vue?vue&type=script&lang=js&"
export * from "./CloseBtn.vue?vue&type=script&lang=js&"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=2b4131e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4131e5",
  null
  
)

export default component.exports